const isRecord = (obj: unknown): obj is Record<string, unknown> =>
  obj !== null && typeof obj === "object";

export const toRecord = (obj: unknown): Record<string, unknown> =>
  isRecord(obj) ? obj : {};

export const toNumber = (val: unknown): number => {
  const n = Number(val);
  return Number.isFinite(n) ? n : 0;
};

export const toArray = <T>(val: unknown): T[] =>
  Array.isArray(val) ? (val as T[]) : [];
